<template>
  <EditDialog
    v-if="showModal"
    v-model:visible="showModal"
    :title="TemplateTypeConfig[formModel.type].title"
    :parent-dom="parentDom"
    :width="800"
    :mask-closable="false"
    :loading="loading"
    :padding="30"
    :is-show-sure="false"
    @close="handleCancel"
    @cancel="handleCancel"
  >
    <template #btn>
      <div class="footer-actions">
        <u-button
          type="primary"
          :loading="loading"
          data-testid="submit-template-button"
          @click="handleSubmit"
        >
          {{
            mode === 'edit'
              ? $t(
                  'views.aiWrite.templateList.components.TemplateInfo.db3c8932727cdd0f440e298bebb0c544'
                )
              : $t(
                  'views.aiWrite.templateList.components.TemplateInfo.9f3d1602618071fc3bb4ce664b74a239'
                )
          }}
        </u-button>
      </div>
    </template>
    <div class="form-flow-wrapper mb-[16px]">
      <u-form
        ref="formRef"
        :model="formModel"
        colon
        :rules="rules"
        layout="labelTop"
      >
        <u-form-item
          prop="name"
          :label="
            $t(
              'views.aiWrite.templateList.components.TemplateInfo.64717cf8282205264d74a2fca2510749'
            )
          "
        >
          <div class="template-name-wrap">
            <div class="template-icon">
              <AgentAvatarPicker
                :key="formModel.avatar_name"
                :icon="+formModel.avatar_name"
                @select="handleAvatarSubmit"
              />
            </div>
            <u-input
              v-model="formModel.name"
              :maxlength="50"
              show-word-limit
              :placeholder="
                $t(
                  'views.aiWrite.templateList.components.TemplateInfo.901c085f4cdd6edd4a4a18570bcc08ca'
                )
              "
            />
          </div>
        </u-form-item>
        <u-form-item
          :label="
            $t(
              'views.aiWrite.templateList.components.TemplateInfo.6677cea2f24c4525b4977cd91dd6a5fd'
            )
          "
          prop="description"
        >
          <div class="answer-wrap">
            <u-input
              v-model="formModel.description"
              type="textarea"
              :maxlength="200"
              show-word-limit
              :placeholder="
                $t(
                  'views.aiWrite.templateList.components.TemplateInfo.a58783c6b144c07b3b051be7a511ef89'
                )
              "
            />
          </div>
        </u-form-item>
        <u-form-item
          :label="
            $t(
              'views.aiWrite.templateList.components.TemplateInfo.cfb821b53d22691a41e7a5ddba0863ad'
            )
          "
          prop="llm_model"
        >
          <u-tooltip
            :title="
              $t(
                'views.botSetting.BotForm.components.BaseForm.55119ccf1efc357e7bfd33aae9c751de'
              )
            "
          >
            <div
              class="model-setting flex-space-between"
              data-testid="open-model-setting-button"
              @click="handleOpenModelSetting"
            >
              <span class="ellipsis">{{ formModel.llm_model_name }}</span>
              <svg-icon name="settings-line" padding="0" size="14" />
            </div>
          </u-tooltip>
        </u-form-item>
        <u-form-item
          :label="
            $t(
              'views.aiWrite.template.components.TemplateInfoDiaglog.6e2d2628c27de63ad03aadd1f94ca221'
            )
          "
          prop="search_type"
        >
          <div class="search-type-cards" :class="{ disabled: mode === 'edit' }">
            <div
              class="search-type-card"
              :class="{ active: formModel.search_type === 1 }"
              data-testid="select-template-library-card"
              @click="mode !== 'edit' && (formModel.search_type = 1)"
            >
              <div class="card-body">
                <img
                  src="@/assetsCommon/aiwrite/knowledge-type.svg"
                  class="card-icon"
                  alt=""
                />
                <div class="card-text">
                  <div class="card-title">
                    {{
                      $t(
                        'views.aiWrite.template.components.TemplateInfoDiaglog.800c9ac45386bbb41e2a9f1573105faa'
                      )
                    }}
                  </div>
                  <div class="card-desc">
                    {{
                      $t(
                        'views.aiWrite.template.components.TemplateInfoDiaglog.464033d5cc716ed6a6c82a4a733b82bc'
                      )
                    }}
                  </div>
                </div>
              </div>
              <svg
                v-if="formModel.search_type === 1"
                class="check-icon"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 8L6.5 11.5L13 5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div
              class="search-type-card"
              :class="{ active: formModel.search_type === 2 }"
              data-testid="select-knowledge-base-card"
              @click="mode !== 'edit' && (formModel.search_type = 2)"
            >
              <div class="card-body">
                <img
                  src="@/assetsCommon/aiwrite/knowledge-type.svg"
                  class="card-icon"
                  alt=""
                />
                <div class="card-text">
                  <div class="card-title">
                    {{
                      $t(
                        'views.aiWrite.template.components.TemplateInfoDiaglog.2c42fc306dff9bc1ecde1cfef1795c8f'
                      )
                    }}
                  </div>
                  <div class="card-desc">
                    {{
                      $t(
                        'views.aiWrite.template.components.TemplateInfoDiaglog.949746b7eba06a6bcf6c0bf54f938e48'
                      )
                    }}
                  </div>
                </div>
              </div>
              <svg
                v-if="formModel.search_type === 2"
                class="check-icon"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 8L6.5 11.5L13 5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </u-form-item>
        <u-form-item
          v-if="formModel.search_type === 2"
          :label="
            $t(
              'views.aiWrite.template.components.TemplateInfoDiaglog.df5c55ed6809e5b84c34bbc9f8271838'
            )
          "
          prop="index_name"
        >
          <u-select
            v-model="formModel.index_name"
            :disabled="mode === 'edit'"
            style="width: 100%"
          >
            <u-option
              :value="1"
              :label="
                $t(
                  'views.aiWrite.template.components.TemplateInfoDiaglog.210326088d93707500f6e5dc25a99e51'
                )
              "
            />
          </u-select>
        </u-form-item>
      </u-form>
      <div class="flex items-center">
        <LangModelSelect
          ref="langModelSelectRef"
          v-model:language="formModel.emb_language"
          v-model:model="formModel.emb_model"
          resolve-unavailable-model
        />
      </div>
    </div>
    <ModelSetting ref="modelSetting" @submit="handleModel" />
  </EditDialog>
</template>
<script>
import { useI18n } from 'vue-i18n';
import { defineComponent, ref, computed } from 'vue';
import { message } from '@koi-design/uxd-ui';
import LangModelSelect from '@/components/LangModelSelect.vue';
import { addAiWrite, updateAiWrite, copyAiWrite } from '@/api/aiwrite';
import { getModelListApi } from '@/api/robot';
import { applyAiWriteLlmModelResolve } from '@/libs/resolveModelReplacement';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import AgentAvatarPicker from '@/components/AgentAvatar/picker.vue';
import ModelSetting from './ModelSetting.vue';

export default defineComponent({
  name: 'TemplateInfoDialog',
  components: {
    LangModelSelect,
    ModelSetting,
    AgentAvatarPicker
  },
  props: {
    parentDom: {
      type: String,
      default: '#ai-write'
    }
  },
  emits: ['success'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const TemplateTypeConfig = {
      add: {
        title: t(
          'views.aiWrite.templateList.components.TemplateInfo.92d4ef2c292e95230b3359d5b223b57d'
        ),
        api: addAiWrite
      },
      edit: {
        title: t(
          'views.aiWrite.templateList.components.TemplateInfo.ccfc8feeb9155e9b6684604195f71e42'
        ),
        api: updateAiWrite
      },
      copy: {
        title: t(
          'views.aiWrite.templateList.components.TemplateInfo.b32e5862138161528ec5cc722e9c4f8a'
        ),
        api: copyAiWrite
      }
    };
    const store = useStore();
    const homelandInfo = computed(() => {
      return store.getters.homelandInfo;
    });
    const mode = ref('add');
    const showModal = ref(false);
    const formRef = ref(null);
    const loading = ref(false);
    const langModelSelectRef = ref();
    const defaultFormModel = {
      name: '',
      description: '',
      llm_model: '',
      llm_model_name: '',
      divergence: '',
      top_p: '',
      max_tokens: '',
      emb_language: '',
      emb_model: '',
      avatar_name: '',
      search_type: 1,
      index_name: 1
    };
    const formModel = ref({
      ...defaultFormModel
    });
    const aiWriteModelOptions = ref([]);
    const rules = {
      name: [
        {
          required: true,
          message: t(
            'views.aiWrite.templateList.components.TemplateInfo.901c085f4cdd6edd4a4a18570bcc08ca'
          )
        }
      ],
      description: [
        {
          required: true,
          message: t(
            'views.aiWrite.templateList.components.TemplateInfo.a58783c6b144c07b3b051be7a511ef89'
          )
        }
      ],
      llm_model: [
        {
          required: true,
          message: t(
            'views.aiWrite.templateList.components.TemplateInfo.a58783c6b144c07b3b051be7a511ef89'
          )
        }
      ]
    };
    const router = useRouter();
    const handleSubmit = async () => {
      if (loading.value) return;
      const statusSArr = await Promise.allSettled([
        langModelSelectRef.value.validate(),
        formRef.value.validate()
      ]);
      if (statusSArr.some(p => p.status === 'rejected')) {
        return;
      }
      const { api } = TemplateTypeConfig[formModel.value.type];
      try {
        loading.value = true;
        const res = await api({
          ...formModel.value,
          homeland_id: homelandInfo.value.homeland
        });
        if (res) {
          showModal.value = false;
          emit('success');

          if (mode.value === 'add') {
            await router.push({
              path: '/aiWriteTemplate',
              query: {
                templateId: res.template_uuid,
                step: 1
              }
            });
          }
        }
      } catch (error) {
        // The API layer rejects with the backend message; surface it as is.
        message.error(error);
      } finally {
        loading.value = false;
      }
    };
    const handleCancel = () => {
      showModal.value = false;
      formModel.value = {};
      formRef.value.resetFields();
    };
    const loadAiWriteModelOptions = async () => {
      aiWriteModelOptions.value = await getModelListApi({
        homeland_id: homelandInfo.value.homeland,
        option_type: 'ai_write'
      });
    };
    const resolveLlmModel = async () => {
      try {
        await loadAiWriteModelOptions();
        await applyAiWriteLlmModelResolve(formModel.value, aiWriteModelOptions);
      } catch {
        // Model resolution is optional and must not block the dialog.
      }
    };
    const show = async ({ type, data }) => {
      loading.value = false;
      if (type === 'add') {
        formModel.value = {
          type: 'add',
          ...defaultFormModel,
          ...data
        };
      } else {
        formModel.value = {
          type,
          ...data,
          search_type: Number(data.search_type) || 1,
          index_name: Number(data.index_name) || 1
        };
        formModel.value.id = '';
      }
      mode.value = type;
      await resolveLlmModel();
      showModal.value = true;
    };
    const modelSetting = ref(null);
    const handleOpenModelSetting = () => {
      modelSetting.value.show(formModel.value);
    };
    const handleModel = data => {
      formModel.value = data;
    };

    const handleAvatarSubmit = data => {
      formModel.value.avatar_name = data.icon;
    };
    return {
      mode,
      show,
      loading,
      showModal,
      formRef,
      formModel,
      rules,
      TemplateTypeConfig,
      handleSubmit,
      handleCancel,
      langModelSelectRef,
      modelSetting,
      handleOpenModelSetting,
      handleModel,
      handleAvatarSubmit
    };
  }
});
</script>
<style lang="less" scoped>
.model-setting {
  box-sizing: border-box;
  background-color: var(--form-background-color);
  height: 40px;
  position: relative;
  color: var(--active-font-color);
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
}

.settings-icon-wrapper {
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
}

.template-name-wrap {
  display: flex;
  .template-icon {
    margin-right: 8px;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    flex-shrink: 0;
    overflow: hidden;
  }
}

.search-type-cards {
  display: flex;
  gap: 12px;
  width: 100%;

  &.disabled {
    pointer-events: none;
    opacity: 0.6;
  }
}

.search-type-card {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 1px solid var(--border-neutral-color-secondary);
  border-radius: 8px;
  cursor: pointer;
  background: #fff;
  transition: border-color 0.2s, background 0.2s;

  &:hover {
    border-color: var(--primary-color);
  }

  &.active {
    border-color: var(--primary-color);
    background: var(--primary-color-bg, #fafbff);
  }

  .card-body {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    .card-icon {
      width: 40px;
      height: 40px;
      flex-shrink: 0;
    }
    .card-text {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  }

  .card-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-text-neutral-primary, #1f1f1f);
    line-height: 22px;
  }

  .card-desc {
    font-size: 12px;
    color: var(--color-text-text-tertiary, #8c8c8c);
    line-height: 20px;
  }

  .check-icon {
    flex-shrink: 0;
    color: var(--primary-color);
    align-self: flex-start;
    margin-top: 13px;
  }
}
</style>
